import { Navigate } from 'react-router';

import { PERM } from '#/config/permissions';
import { ROUTES } from '#/config/routes';
import { useCan } from '#/modules/infra/auth/useCan';

import PurchaseOrderListPage from './PurchaseOrderListPage';

const PurchaseOrderListGate = () => {
  const canReadMaterial = useCan(PERM.PURCHASE_ORDER_READ);

  if (!canReadMaterial) {
    return <Navigate to={ROUTES.miscPurchaseOrder} replace />;
  }

  return <PurchaseOrderListPage />;
};

export default PurchaseOrderListGate;
